
define('timespan',[],function() {
    'use strict';
    
    function TimeSpan(milliseconds) {
        this._milliseconds = +milliseconds || 0;
    }

    TimeSpan.prototype.valueOf = function () {
        return this._milliseconds;
    };

    TimeSpan.prototype.toString = function () {
        return this.toJSON();
    };

    TimeSpan.prototype.toJSON = function () {
        var msRemaining = this._milliseconds;

        var hours = Math.floor(msRemaining / (60 * 60 * 1000));
        msRemaining -= hours * (60 * 60 * 1000);

        var minutes = Math.floor(msRemaining / (60 * 1000));
        msRemaining -= minutes * (60 * 1000);

        var seconds = msRemaining / 1000;

        return [hours, minutes, seconds].join(':');
    };

    TimeSpan.prototype.seconds = function () {
        return this._milliseconds / 1000;
    };

    return TimeSpan;
    
});